import { Injectable } from '@angular/core';
import {
    HttpRequest,
    HttpHandler,
    HttpEvent,
    HttpInterceptor,
    HttpErrorResponse,
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AuthService } from '../auth.service';
import { BulkUploadService } from 'src/app/bulkupload.service';
import { UserData } from '../userData';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
    constructor(private authService: AuthService) {}

    intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
        return next.handle(request).pipe(
            catchError((error) => {
                if (error instanceof HttpErrorResponse) {
                    if (error.status === 401) {
                        let URL = request.url;

                        let loginUrlEndpointMatch = 'login?api=core';

                        const regexString = loginUrlEndpointMatch.replace(
                            /[.*+?^${}()|[\]\\]/g,
                            '\\$&',
                        ); //to escape specialchar, since we have ? in endpointurl
                        let regExpression = new RegExp(regexString + '$');

                        if (URL.match(regExpression)) {
                            this.authService.presentToastWithOptions(
                                error.error.message,
                                'secondary',
                            );
                            return throwError(error);
                        } else {
                            this.authService.logout();
                            return throwError(error);
                        }
                    }
                }

                let errorMessage = 'An Unknown Error Occured';
                if (error?.error?.errorMessage) {
                    errorMessage = error.error.errorMessage;
                } else if (error?.error?.message) {
                    errorMessage = error.error.message;
                }
                console.log('error interceptor', error);
                this.authService.presentToastWithOptions(errorMessage, 'secondary');

                return throwError(error);
            }),
        );
    }
}
